import colors from 'theme/colors';
import { StationIconProps } from './types';

export const Transition = ({ background = colors.coral[700], color = colors.white, ...rest }: StationIconProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path
                d="M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z"
                fill={background}
                stroke={background}
                strokeWidth="2"
            />
            <path
                d="M15.1111 23.1128H9.77778C9.30628 23.1128 8.8541 22.9255 8.5207 22.5921C8.1873 22.2587 8 21.8066 8 21.3351V10.6684C8 10.1969 8.1873 9.74472 8.5207 9.41132C8.8541 9.07793 9.30628 8.89062 9.77778 8.89062H15.1111"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M20.4443 17.7773V23.9996" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.4443 8V14.2222" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M17.7773 21.332L20.444 23.9987L23.1107 21.332"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.7773 10.6667L20.444 8L23.1107 10.6667"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
